/**
 * Created by lsubramaniam on 4/17/18.
 */
import { EventList } from './event-list';

export class EventListeners {
  event: EventList;
  listeners: Function[] = [];
}
